import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Allocation bars always show USED. Traffic light: healthy / getting tight / nearly gone.
export function usageBarColor(usedPct) {
  if (usedPct >= 90) return 'bg-red-500';
  if (usedPct >= 70) return 'bg-[#FBCC49]';
  return 'bg-emerald-500';
}
